import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      /* eslint-disable-next-line no-undef */
      filterKeys: [__SENTRY_APPLICATION_KEY__],
      behaviour: "drop-error-if-exclusively-contains-third-party-frames",
    }),
  ],
});

const router = createBrowserRouter([
  {
    path: "*",
    element: <App />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
